// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { scopeSchema } from './scope'

/**
 * Uma linha da matriz de permissões POR ESCOPO — a forma real de
 * `GET /users/:id` → `data.users.scopes[]` (spec 006, US4/T027).
 *
 * Cuidado com o nome: `granted` é **efetivo** (grants − denies) e já traz a
 * `base` materializada; NÃO é "só os extras". `base` é o piso do papel
 * (`ROLE_BASE_PERMISSIONS`) e existe mesmo em escopo sem nenhuma linha em
 * `user_permissao` — por isso a UI a mostra travada. O extra concedido é
 * `granted − base`, calculado no consumidor.
 *
 * Contrato narrativo: `portal-senne-exames/specs/006-rbac-completo/contracts/get-user.md`.
 */
export const scopeMatrixEntrySchema = z.object({
    scopeType: scopeSchema,
    /** `null` em escopo sem alvo (GLOBAL/SELF). */
    scopeId: z.number().nullable(),
    base: z.array(z.number()),
    granted: z.array(z.number()),
})
export type ScopeMatrixEntry = z.infer<typeof scopeMatrixEntrySchema>
